export const QUERY_PARAMS = {
  task: {
    id: 'id',
    selectedTask: 'selectedTask',
    view: 'view',
  },
  comment: {
    comment: 'comment',
    replyComment: 'replyComment',
  }
}

export enum QUERY_PARAMS_VALUE {
  detail = 'detail',
  modal = 'modal',
};
